// Core
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';


// Assets
import { Button, Modal, Skeleton } from 'antd';
import { Label } from 'assets/styles/globalStyles';
import { FontSizes, FontWeight } from 'utils/enums';
import { colors } from 'assets/styles/colors';
import { motion } from "framer-motion";
import { CloseOutlined } from '@ant-design/icons';
import ReactPlayer from 'react-player';


const ArticleView = (props: any) => {
    const { onClose, open, data } = props;
    const { currentLang } = useSelector((store: any) => store.commonData);
    const [isLoading, setLoading] = useState(false);
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Modal open={open} onCancel={onClose} footer={null} width={900} centered
        keyboard={true}
        closable={false}
        maskClosable={true}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px', marginTop: '10px', borderBottom: '1px solid #E5E5E5' }}>
                <Label fontWeight={FontWeight.bold} color={colors.primary} fontSize={FontSizes.h2}></Label>
                <Button type="text" icon={<CloseOutlined />} onClick={onClose} style={{ fontSize: 20 }} />
            </div>
            {isLoading ? (
                <div className="container __articles_list" style={{ paddingTop: '20vh', paddingBottom: '6%' }}>
                    <div className="row">
                        <div className='col-md-4 mb-5'>
                            <Skeleton.Image active style={{ width: '300px', height: '400px' }} />
                        </div>
                        <div className='col-md-8'>
                            <Skeleton active paragraph={{ rows: 5 }} />
                        </div>
                    </div>
                </div>
            ) : (
                <div className='container' style={{maxHeight: '80vh', overflowY: 'auto'}}>
                    <div className='row'>
                        <motion.div
                            className='col-md-5 mb-3'
                            initial={{ opacity: 0, x: -50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.5 }}
                        >
                            <img
                                className="__cover_im_book imageLoader"
                                src={data?.publicationIcon}
                                alt={data?.name}
                                style={{
                                    objectFit: 'cover',
                                    borderRadius: '10px',
                                    minHeight: '400px',
                                    backgroundColor: '#E5E5E5',
                                    width: '100%',
                                }}
                            />

                        </motion.div>
                        <div className='col-md-7' >
                            <motion.div
                                className='mb-4 d-flex flex-column'
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5 }}
                            >
                                <Label className="fade-left" fontSize={FontSizes.h1} fontWeight={FontWeight.bold} marginTop={0} marginBottom={5}>{data?.name}</Label>
                            </motion.div>
                            <motion.div
                                className='mb-3 d-flex flex-column'
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5 }}
                                style={{ textAlign: 'justify', lineHeight: '2', fontSize: '16px' }}
                                dangerouslySetInnerHTML={{ __html: data?.body || '' }}
                            >
                            </motion.div>

                            {data && data?.videoURL && <div className='__video_sec mb-2'>
                                <div className='player-wrapper'>
                                    <ReactPlayer url={data?.videoURL} controls={true}
                                        className='react-player'
                                        width='100%'
                                        height='100%'
                                    />
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            )
            }

        </Modal>
    );
};

export default ArticleView;
